import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function useReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => el.classList.add('visible'), delay);
          obs.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);
  return ref;
}

const cards = [
  {
    label: 'BUY A HOME.',
    desc: 'Find the right home with inspection-level insight at every step.',
    link: '/buying',
    cta: 'Start Your Search',
    img: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/75ce2a6bf01907ba0f3148f6c0765708.jpeg',
  },
  {
    label: 'SELL A HOME.',
    desc: 'Complimentary home value analysis and a results-driven marketing plan.',
    link: '/selling',
    cta: 'Get Your Value',
    img: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/78e45c3c24fb61c39cd4e29693b0f6f7.jpeg',
  },
  {
    label: 'FREE RESOURCES.',
    desc: 'Buyer guides, seller guides, and tools to help you move confidently.',
    link: '/resources',
    cta: 'Explore Resources',
    img: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/bbcdb6571347c6e4b9a0f7ca9a7bbc3e.jpeg',
  },
];

export default function HomeServiceCards() {
  const card0 = useReveal(0);
  const card1 = useReveal(150);
  const card2 = useReveal(300);
  const refs = [card0, card1, card2];

  return (
    <section className="py-14 sm:py-20 bg-[#FAF9F7]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              ref={refs[i]}
              className="reveal scale group relative overflow-hidden rounded-lg cursor-pointer"
            >
              <div className="relative h-[320px] sm:h-[400px] md:h-[460px]">
                <img
                  src={card.img}
                  alt={card.label}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-black/5"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
                  <h3 className="font-cormorant text-2xl sm:text-3xl font-semibold text-white mb-2 leading-tight">{card.label}</h3>
                  <p className="text-white/80 text-sm leading-relaxed mb-4 sm:mb-5">{card.desc}</p>
                  <Link
                    to={card.link}
                    className="inline-flex items-center gap-2 text-[#C8923A] text-sm font-semibold tracking-wide hover:gap-3 transition-all whitespace-nowrap"
                  >
                    {card.cta}
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
